module.exports = __webpack_public_path__ + "img/labmem_text_language_jp.2fa69a94.png";